// @ts-nocheck

/**
 * YPM_LONGTEXT_SRV
 * Longtext  ## Entity Data Model ![ER Diagram](https://yuml.me/diagram/class/[Text{bg:orange}],[TextSet{bg:dodgerblue}]++-*>[Text])  ### Legend ![Legend](https://yuml.me/diagram/plain;dir:TB;scale:60/class/[External.Type{bg:whitesmoke}],[ComplexType],[EntityType{bg:orange}],[EntitySet/Singleton/Operation{bg:dodgerblue}])
 *
 * The version of the OpenAPI document: 0001
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ModelError } from '../model/models';
import { Text } from '../model/models';
import { Wrapper } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class TextSetService {

    protected basePath = 'https://dkasub.corp.lego.com:1443/sap/opu/odata/sap/YPM_LONGTEXT_SRV';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get entities from TextSet
     * @param $filter Filter items by property values, see [Filtering](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;64)
     * @param $inlinecount Include count of items, see [Inlinecount](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;67)
     * @param $orderby Order items by property values, see [Sorting](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;65)
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public textSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'object' | 'object desc' | 'name' | 'name desc' | 'id' | 'id desc' | 'language' | 'language desc' | 'title' | 'title desc' | 'longText' | 'longText desc'>, $select?: Array<'object' | 'name' | 'id' | 'language' | 'title' | 'longText'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Wrapper>;
    public textSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'object' | 'object desc' | 'name' | 'name desc' | 'id' | 'id desc' | 'language' | 'language desc' | 'title' | 'title desc' | 'longText' | 'longText desc'>, $select?: Array<'object' | 'name' | 'id' | 'language' | 'title' | 'longText'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Wrapper>>;
    public textSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'object' | 'object desc' | 'name' | 'name desc' | 'id' | 'id desc' | 'language' | 'language desc' | 'title' | 'title desc' | 'longText' | 'longText desc'>, $select?: Array<'object' | 'name' | 'id' | 'language' | 'title' | 'longText'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Wrapper>>;
    public textSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'object' | 'object desc' | 'name' | 'name desc' | 'id' | 'id desc' | 'language' | 'language desc' | 'title' | 'title desc' | 'longText' | 'longText desc'>, $select?: Array<'object' | 'name' | 'id' | 'language' | 'title' | 'longText'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$filter, '$filter');
        }
        if ($inlinecount !== undefined && $inlinecount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$inlinecount, '$inlinecount');
        }
        if ($orderby) {
            queryParameters = this.addToHttpParams(queryParameters,
                $orderby.join(COLLECTION_FORMATS['csv']), '$orderby');
        }
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Wrapper>(`${this.configuration.basePath}/TextSet`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get entity from TextSet by key
     * @param object Texts: application object   In business applications, a text is not considered an independent object. A text can only exist if it has a superior reference object. A material inspection text, for example, only exists if there is a corresponding material. The application object of a text is therefore the global environment in which a text exists.
     * @param name Name   This is the text name of a text. It can be a maximum of 70 characters in length. However, in specific text applications, only shorter names are usually allowed.   Do not use the characters \&#39;,\&#39; or \&#39;*\&#39; in the text name or leave it blank.
     * @param id The text ID defines the various types of texts related to a text object. For example, the object \&quot;TEXT\&quot; (standard texts) can have the following text IDs:   ST for user-specific standard texts (individual texts)   SYST for cross-application system texts   various IDs for specific application departments. You must have the appropriate access authorization in order to access these texts.
     * @param language Language Key   The language key indicates   - the language in which texts are displayed,   - the language in which you enter texts,   - the language in which the system prints texts.
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public textSetObjectobjectnamenameididlanguagelanguageGet(object: string, name: string, id: string, language: string, $select?: Array<'object' | 'name' | 'id' | 'language' | 'title' | 'longText'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Text>;
    public textSetObjectobjectnamenameididlanguagelanguageGet(object: string, name: string, id: string, language: string, $select?: Array<'object' | 'name' | 'id' | 'language' | 'title' | 'longText'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Text>>;
    public textSetObjectobjectnamenameididlanguagelanguageGet(object: string, name: string, id: string, language: string, $select?: Array<'object' | 'name' | 'id' | 'language' | 'title' | 'longText'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Text>>;
    public textSetObjectobjectnamenameididlanguagelanguageGet(object: string, name: string, id: string, language: string, $select?: Array<'object' | 'name' | 'id' | 'language' | 'title' | 'longText'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (object === null || object === undefined) {
            throw new Error('Required parameter object was null or undefined when calling textSetObjectobjectnamenameididlanguagelanguageGet.');
        }
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling textSetObjectobjectnamenameididlanguagelanguageGet.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling textSetObjectobjectnamenameididlanguagelanguageGet.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling textSetObjectobjectnamenameididlanguagelanguageGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Text>(`${this.configuration.basePath}/TextSet(object='${encodeURIComponent(String(object))}',name='${encodeURIComponent(String(name))}',id='${encodeURIComponent(String(id))}',language='${encodeURIComponent(String(language))}')`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
